import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function prefersReducedMotion() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// Scroll-reveal a set of children inside a container ref
export function useScrollReveal(selector = "[data-reveal]", opts = {}) {
  const ref = useRef(null);
  useEffect(() => {
    if (prefersReducedMotion() || !ref.current) return;
    const ctx = gsap.context(() => {
      const els = ref.current.querySelectorAll(selector);
      els.forEach((el) => {
        gsap.fromTo(
          el,
          { y: 40, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.9,
            ease: "power3.out",
            scrollTrigger: { trigger: el, start: opts.start || "top 85%" },
          }
        );
      });
    }, ref);
    return () => ctx.revert();
  }, [selector, opts.start]);
  return ref;
}

export { gsap, ScrollTrigger };
